<template>
  <div>
    <v-menu
      v-model="isMenuOpen"
      :close-on-content-click="false"
      :disabled="disabled"
      :max-width="maxWidth"
      :location="location"
      :open-on-hover="openOnHover"
      transition="fade-transition"
      activator="parent"
    >
      <template #activator="{ props }">
        <slot name="trigger" v-bind="props" />
      </template>

      <v-card elevation="0" class="menu-card pa-3 row-gap-2 d-flex flex-column" :class="cardClass">
        <v-card-text class="text--small text--regular pa-0">
          <slot />
        </v-card-text>
        <v-card-actions v-if="$slots.actions" class="menu-actions pa-0 column-gap-3">
          <slot name="actions" />
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'Popover',
  data () {
    return {
      isMenuOpen: false,
    }
  },
  props: {
    cardClass: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    location: {
      type: String,
      default: 'top',
    },
    openOnHover: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [String, Number],
      default: 'auto',
    },
  },
  methods: {
    open () {
      this.isMenuOpen = true
    },
    close () {
      this.isMenuOpen = false
    },
  },
}
</script>

<style scoped lang="scss">
.menu-card {
  background: white;
  border: 1px solid rgb(var(--v-theme-grey-200));
  box-shadow: 0 0 12px 0 rgba(var(--v-theme-grey-700), 0.08) !important;
  border-radius: 10px !important;

  .v-card-text {
    letter-spacing: normal;
  }
}

.menu-actions {
  display: flex;
  justify-content: flex-end;
  min-height: auto;
}
</style>
